import React from 'react'
import Players from './players'

const Dashboard = () => {
  return (
    <div>
      <Players />
    </div>
  )
}

export default Dashboard